var map = {
	"./0.png": 5959,
	"./1.png": 4476,
	"./2.png": 5342,
	"./3.png": 6757,
	"./4.png": 3829,
	"./5.png": 1909,
	"./down.png": 5245,
	"./main.png": 8310,
	"./qa.png": 8470,
	"./right.png": 8057,
	"./use.png": 5878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7591;